<template>
    <div class="ports">
        <vu-nav title="Ports">
            <v-tab to="/ports/list">List</v-tab>
        </vu-nav>
        <v-container>
            <router-view />
        </v-container>
    </div>
</template>
